import { render } from "./ShortLongLabel.vue?vue&type=template&id=7a1963ce&scoped=true"
import script from "./ShortLongLabel.vue?vue&type=script&lang=js"
export * from "./ShortLongLabel.vue?vue&type=script&lang=js"

import "./ShortLongLabel.vue?vue&type=style&index=0&id=7a1963ce&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a1963ce"]])

export default __exports__